
import { Component, Vue } from "vue-property-decorator";
import {
  IDefaultShippingOrderModel,
  ITypeModel,
} from "@/api/types";
import { QuotationApprovalDetail } from "./types";

import Pagination from "@/components/Pagination/index.vue";
import { Form } from "element-ui";
import moment from "moment";
import { getPayment, payment, getPaymentMethod } from "@/api/purchase-order";
import {
  getQuotationDetail,
  removeQuotation,
} from "@/api/inquiry";
import {
  getDetailHeader,
} from "@/api/proforma";
import { getRelationList } from "@/api/supplier-payment";
import { ShippingOrderModel } from "@/model/shipping-order";
import { COMPANY_OPTIONS } from "@/constant";
import { cal } from "@/utils/cal";

@Component({
  name: "quotationDetails",
  components: {
    Pagination,
    CreateFee: () => import("./components/CreateFee.vue"),
    Receipt: () => import("./components/Receipt.vue"),
  },
})
export default class extends Vue {
  // 是否显示所有产品号码
  private showFee = false;
  private showAmount = false;
  private selectedItem = {} as any;
  private tableKey = 0;
  private companyCodeOptions = COMPANY_OPTIONS;
  private containerTypeOptionsList: ITypeModel[] = [];
  public shippingOrder: IDefaultShippingOrderModel[] = [];
  private total = 0;
  private listLoading = true;
  private selectedRow: ShippingOrderModel = new ShippingOrderModel();

  private conversionExchangeRate = 0;

  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as QuotationApprovalDetail[],
  };

  public tableCol = [
    {
      label: "S/N",
      prop: "sn",
      key: "sn",
      show: true,
      fixed: true,
      disabled: false,
    },
    {
      label: "收汇单号",
      prop: "shippingCode",
      key: "shippingCode",
      show: true,
      disabled: false,
    },
    {
      label: "收汇单金额",
      prop: "inquiryReferenceNumber",
      key: "inquiryReferenceNumber",
      show: true,
      disabled: false,
    },
    {
      label: "登记金额",
      prop: "inquiryReferenceNumberType",
      key: "inquiryReferenceNumberType",
      show: true,
      disabled: false,
    },
    {
      label: "登记金额类型",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false,
    },
    {
      label: "金额说明",
      prop: "productName",
      key: "productName",
      show: true,
      disabled: false,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        { name: "编辑", code: "", click: "handleEdit" },
        {
          name: "删除",
          code: "",
          click: "handleDelete",
          type: "delete",
        },
      ],
      show: true,
      disabled: false,
      width: 100,
    },
  ] as any;
  public customerInfo = {} as any;
  public customerInfoFields = [
    {
      label: "采购订单号",
      key: "poCode",
    },
    {
      label: "交易公司",
      key: "company",
    },
    {
      label: "当前状态",
      key: "status",
    },
    {
      label: "销售员",
      key: "seller",
    },
    {
      label: "下单时间",
      key: "createTime",
    },
    {
      label: "长期定金",
      key: "",
    },
    {
      label: "产品总数量",
      key: "productQuantity",
    },
    {
      label: "总货款",
      key: "supplierTotalPayment",
    },
    {
      label: "采购订单费用",
      key: "otherFee",
      type: "link",
      click: "handleOtherFeeClick",
    },
    {
      label: "结算金额",
      key: "settlementAmount",
    },
    {
      label: "备注",
      key: "remark",
    },
  ] as any;
  public paymentForm = {
    paymentMethod: null,
    deposit: true,
    depositAmount: null,
    paymentDetail: null,
    paymentRemark: null,
    tradingTerms: null,
    accountPeriod: null,
    orderAuditor: null,
    deliveryTime: null,
    otherFeeReqList: [],
    poPaymentVoucherReqList: [],
  } as any;
  private paymentMethodOptions = [] as any[];
  private depositDisabled = false;
  private get paymentRules() {
    return {
      paymentMethod: [
        {
          required: true,
          message: "请选择付款方式",
          trigger: "change",
        },
      ],
      depositAmount: [
        {
          required: !!this.paymentForm.deposit,
          message: "请输入定金金额",
          trigger: "blur",
        },
      ],
    };
  }
  private feeTable = [];
  public feeCol = [
    {
      label: "S/N",
      prop: "sn",
      key: "sn",
      show: true,
      fixed: true,
      disabled: false,
    },
    {
      label: "费用类型",
      prop: "shippingCode",
      key: "shippingCode",
      show: true,
      disabled: false,
    },
    {
      label: "金额",
      prop: "inquiryReferenceNumber",
      key: "inquiryReferenceNumber",
      show: true,
      disabled: false,
    },
    {
      label: "备注",
      prop: "inquiryReferenceNumberType",
      key: "inquiryReferenceNumberType",
      show: true,
      disabled: false,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        { name: "编辑", code: "", click: "handleEdit" },
        {
          name: "删除",
          code: "",
          click: "handleDelete",
          type: "delete",
        },
      ],
      show: true,
      disabled: false,
      width: 100,
    },
  ] as any;
  private recordTable = [];
  public recordCol = [
    {
      label: "收汇单号",
      prop: "sn",
      key: "sn",
      show: true,
      fixed: true,
      disabled: false,
    },
    {
      label: "收汇单金额",
      prop: "shippingCode",
      key: "shippingCode",
      show: true,
      disabled: false,
    },
    {
      label: "未分配金额",
      prop: "inquiryReferenceNumber",
      key: "inquiryReferenceNumber",
      show: true,
      disabled: false,
    },
    {
      label: "已登记金额",
      prop: "inquiryReferenceNumberType",
      key: "inquiryReferenceNumberType",
      show: true,
      disabled: false,
    },
    {
      label: "到账日期",
      prop: "inquiryReferenceNumberType",
      key: "inquiryReferenceNumberType",
      show: true,
      disabled: false,
    },
    {
      label: "收汇单备注",
      prop: "inquiryReferenceNumberType",
      key: "inquiryReferenceNumberType",
      show: true,
      disabled: false,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        { name: "分配明细", code: "", click: "handleEdit" },
        { name: "金额登记", code: "", click: "handleEdit" },
      ],
      show: true,
      disabled: false,
      width: 100,
    },
  ] as any;
  private id = "";
  private supplierId = "";
  private paymentInfo = {};
  private piInfo = {};
  private info = {} as any;
  private otherFeesArray = [] as any;
  private or_supplierTotalPayment = 0;
  created() {
    this.id = this.$route.query.id as string;
    this.supplierId = this.$route.query.supplierId as string;
    this.init();
  }

  activated() {
    this.init();
  }

  private async init() {
    await this.getDetailHeader();
    await this.getPaymentMethod();
    await this.getPayment();
    // this.getList();
  }
  private async getDetailHeader() {
    const res: any = await getDetailHeader(this.id);
    this.info = res;
    this.or_supplierTotalPayment = res.supplierTotalPayment;
  }

  private otherFeeVisible =false;
  private otherFeeTable = {
    list: [],
    info: {},
    tableCol: [
      {
        label: "费用名称",
        prop: "name",
        key: "name",
        show: true,
        disabled: false,
      },
      {
        label: "金额(人民币)",
        prop: "amount",
        key: "amount",
        show: true,
        disabled: false,
      },
      {
        label: "分配比率",
        prop: "distributionRatio",
        type: "link",
        click: "handleDistributionDetail",
      },
      {
        label: "备注",
        prop: "remark",
        key: "remark",
        show: true,
        disabled: false,
      },
    ]
  };
  private otherFeeDetailVisible = false;
  private otherFeeDetailTable = {
    list: [],
    tableCol: [
      {
        label: "单据类型",
        prop: "type",
        key: "type",
        show: true,
        disabled: false,
      },
      {
        label: "单据号码",
        prop: "orderCode",
        key: "orderCode",
        show: true,
        disabled: false,
      },
      {
        label: "分配金额",
        prop: "distributeAmount",
        key: "distributeAmount",
        show: true,
        disabled: false,
      },
      {
        label: "分配日期",
        prop: "distributeDate",
        key: "distributeDate",
        show: true,
        disabled: false,
      },
      {
        label: "分配人",
        prop: "distributeUser",
        key: "distributeUser",
        show: true,
        disabled: false,
      },
    ]
  }
  private handleOtherFeeClick() {
    this.otherFeeVisible = true;
    this.otherFeeTable.info = {
      purchaseOrderCode: this.info.poCode,
      productTotalAmount: this.info.supplierTotalPayment,
      supplier: this.info.supplierAbbreviation,
    }
    this.otherFeeTable.list = this.info.purchaseOrderOtherFeeResList;
  }
  // 分配详情
  private handleDistributionDetail(scope) {
    this.otherFeeDetailTable.list = scope.row.distributionDetail;
    this.otherFeeDetailVisible = true;
  }

  private inputChange(val) {
    this.otherFeesArray = val;
    this.info.supplierTotalPayment = this.or_supplierTotalPayment;
    val.forEach((res) => {
      if (res.amount) {
        this.info.supplierTotalPayment = (+cal.jia(
          this.info.supplierTotalPayment,
          res.amount
        )).toFixed(0);
      }
    });
  }

  private formUpdate(obj) {
    if (!obj.deposit) {
      this.paymentForm.depositAmount = null;
    }
    this.depositDisabled = obj.paymentMethod === "PAY_BEFORE_ORDER";
  }

  private handleDepositChange(value) {
    if (!value) {
      this.paymentForm.depositAmount = null;
    }
  }

  private handlePaymentMethodChange(value) {
    this.depositDisabled = value === "PAY_BEFORE_ORDER";
  }

  private get deliveryDaysText() {
    const deliveryTime = this.paymentForm.deliveryTime;
    const createTime = this.info.createTime;
    if (!deliveryTime || !createTime) {
      return "--";
    }
    const deliveryDate = this.parseDay(deliveryTime);
    const createDate = this.parseDay(createTime);
    if (!deliveryDate || !createDate) {
      return "--";
    }
    return `${deliveryDate.diff(createDate, "days")}天`;
  }

  private get deliveryTimePickerOptions() {
    return {
      disabledDate: (time: Date) => {
        const currentDate = moment(time).startOf("day");
        const createDate = this.parseDay(this.info.createTime);
        const piDeliveryDate = this.parseDay(this.paymentForm.piDeliveryDate);
        if (createDate && currentDate.isBefore(createDate)) {
          return true;
        }
        if (piDeliveryDate && currentDate.isAfter(piDeliveryDate)) {
          return true;
        }
        return false;
      },
    };
  }

  private handleDeliveryTimeChange(value?: string) {
    if (!value) {
      return;
    }
    const deliveryDate = this.parseDay(value);
    if (!deliveryDate) {
      return;
    }
    const createDate = this.parseDay(this.info.createTime);
    if (createDate && deliveryDate.isBefore(createDate)) {
      this.paymentForm.deliveryTime = null;
      this.$message.warning("约定交期不能早于下单日期");
      return;
    }
    const piDeliveryDate = this.parseDay(this.paymentForm.piDeliveryDate);
    if (piDeliveryDate && deliveryDate.isAfter(piDeliveryDate)) {
      this.paymentForm.deliveryTime = null;
      this.$message.warning("约定交期不能晚于PI的交货日期");
    }
  }

  private parseDay(date?: string) {
    if (!date) {
      return null;
    }
    const normalizedDate = String(date).split(" ")[0].split("T")[0];
    const parsedDate = moment(normalizedDate, "YYYY-MM-DD", true).startOf("day");
    return parsedDate.isValid() ? parsedDate : null;
  }

  private formatPiDeliveryDate(date?: string) {
    const parsedDate = this.parseDay(date);
    if (!parsedDate) {
      return "--";
    }
    return parsedDate.format("YYYY年MM月DD日");
  }

  private async getPayment() {
    const res: any = await getPayment(this.id, {
      supplierId: this.supplierId,
    });
    console.log(res);
    this.paymentForm = {
      ...this.paymentForm,
      ...res,
    };
    this.formUpdate(this.paymentForm);
    if (res.otherFeeList.length > 0) {
      this.info.supplierTotalPayment = this.or_supplierTotalPayment;
      res.otherFeeList.forEach((item) => {
        if (item.amount) {
          this.info.supplierTotalPayment = (+cal.jia(
            this.info.supplierTotalPayment,
            item.amount
          )).toFixed(0);
        }
      });
    }
  }

  private async getPaymentMethod() {
    const res: any = await getPaymentMethod();
    this.paymentMethodOptions = res;
  }

  private handleSuccess() {
    this.showFee = false;
    this.getList();
  }

  private handleAddMark() {
    this.paymentForm.markList.push({
      value: "",
    });
  }

  // 删除唛头
  private handleDeleteMark(index) {
    this.paymentForm.markList.splice(index, 1);
  }

  public async handleDelete(scope) {
    await removeQuotation({
      detailId: scope.row.approvalRecordId,
    });
    this.$notify({
      title: "成功",
      message: "删除成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }

  public async handleFee() {
    this.showFee = true;
  }

  public async handleAmount() {
    this.showAmount = true;
  }

  // 选择关联单据
  private async getRelationList() {
    const res: any = await getRelationList({
      supplierId: this.supplierId,
      type: this.paymentForm.paymentMethod,
    });
  }

  private async getList() {
    const params = {
      pageNumber: this.table.pageNumber,
      pageSize: this.table.pageSize,
    };
    this.listLoading = false;
    const { total, list }: any = await getQuotationDetail(params);
    this.table.total = +total;
    this.table.list = list;
    setTimeout(() => {
      this.listLoading = false;
    }, 0.3 * 1000);
  }

  private async submitForm(): Promise<void> {
    (this.$refs.ruleForm as Form).validate(async (valid: boolean) => {
      if (!valid) {
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      try {
        await payment(this.id, {
          ...this.paymentForm,
          otherFeeReqList: this.otherFeesArray,
          poPaymentVoucherReqList: [],
        });
        this.$notify({
          title: "成功",
          message: "保存成功",
          type: "success",
          duration: 2000,
        });
        this.$router.go(-1);
      } catch (error) {
        console.error(error);
      } finally {
        loading.close();
      }
    });
  }
}
